import React from "react";
import TopBar from "../menus/TopBar";
import projects from "../components/artwork-details";
import { useEffect, useRef } from "react";

function Work() {
  const galleryRef = useRef(null);
  const flktyRef = useRef(null);

  useEffect(() => {
    if (!galleryRef.current || !window.Flickity) return;

    const flkty = new window.Flickity(galleryRef.current, {
      wrapAround: true,
      adaptiveHeight: true,
      imagesLoaded: true,
      lazyLoad: 2,
      cellAlign: "center",
      contain: true,
    });

    flktyRef.current = flkty;

    flkty.on("lazyLoad", () => {
      flkty.resize();
    });

    flkty.on("imagesLoaded", () => {
      flkty.resize();
    });

    return () => {
      flkty.destroy();
    };
  }, []);

  return (
    <div className="red-border">
      <div className="white-background">
        <div className="projects-page-max-width">
          <TopBar />
          <div className="selected_projects" id="projects">
            <div className="gallery" ref={galleryRef}>
              {projects.map((project, index) => (
                <div className="gallery-cell" key={index}>
                  <img
                    data-flickity-lazyload={project.image}
                    alt={project.description}
                  />
                  <p className="gallery-caption">{project.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
